import { createSlice, PayloadAction, createAction } from '@reduxjs/toolkit';

import { IState } from 'shared/interfaces/state.interface';
import { TGetOneEntityAction, TVisitStatus } from 'shared/types';
import { initialStore } from '../initial-store';

// Actions
export const createConsultationNote = createAction(
  'visits/CREATE_CONSULTATION_NOTE',
  (payload) => ({ payload })
);

export const deleteConsultationNote = createAction(
  'visits/DELETE_CONSULTATION_NOTE',
  (payload) => ({ payload })
);

// Slice

const visitsSlice = createSlice({
  name: 'visits',
  initialState: initialStore.visits,
  reducers: {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getVisitsData: (state, data: PayloadAction<TVisitStatus | undefined>) => {
      if (!state.isLoading) {
        state.isLoading = true;
      }
    },
    setVisitsData: (state, { payload }) => {
      state.isLoading = false;
      state.allVisits = payload.visits;
      state.countVisits = payload.countVisits;
    },
    getVisitsFail: (state) => {
      state.isLoading = false;
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    getVisit: (state, data: PayloadAction<TGetOneEntityAction>) => {
      state.isLoading = true;
    },
    getVisitsByPatient: (
      state,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      data: PayloadAction<TVisitStatus | undefined>
    ) => {
      state.isLoading = true;
    },
    setVisit: (state, { payload }) => {
      state.isLoading = false;
      state.currentVisit = payload;
    },
    addNewNote: (state, { payload }) => {
      state.currentVisit.notes = state.currentVisit.notes.concat(payload);
    },
    removeNote: (state, { payload }) => {
      state.currentVisit.notes = state.currentVisit.notes.filter(
        ({ id }) => id !== payload
      );
    }
  }
});

export const {
  getVisitsData,
  setVisitsData,
  getVisitsFail,
  getVisit,
  setVisit,
  addNewNote,
  removeNote,
  getVisitsByPatient
} = visitsSlice.actions;

export const { reducer } = visitsSlice;

// Selectors
export const getAllVisitsSelector = (state: IState) =>
  state && state.visits.allVisits;

export const getAllVisitsByPatientSelector = (state: IState) =>
  state && state.visits.allVisits;

export const getVisitsCountSelector = (state: IState) =>
  state && state.visits.countVisits;

export const getVisitsLoadingSelector = (state: IState) =>
  state && state.visits.isLoading;

export const getCurrentVisitSelector = (state: IState) =>
  state && {
    visit: state.visits.currentVisit.data,
    paymentMethod: state.visits.currentVisit.paymentMethod,
    notes: state.visits.currentVisit.notes
  };
